import { PageHeader } from "@/shared/components/PageHeader";
import { LeadsBrowser } from "@/features/campaigns/leads/LeadsBrowser";

/**
 * Leads directory (global nav) — the tenant-wide lead list across all campaigns,
 * with search, filters, pagination and a deep-linkable detail drawer (ADR-0020).
 * Bulk approve/reject work on a manual selection; the screening verdict stays
 * visible with its reason.
 */
export function LeadsPage() {
  return (
    <div>
      <PageHeader
        title="Leads"
        footnote="Every lead discovered across your campaigns — search, filter, and open any one to see everything we collected. Candidates and approved leads are actionable; screened-out rows (duplicates, already-registered) stay visible with their reason."
      />
      <LeadsBrowser />
    </div>
  );
}
